import produce from 'immer';
import { RECEIVERS_MANAGEMENT_ACTIONS } from './actions';
import { POWER_ERROR_CODES } from 'src/common/components/AgGridDataTable/renderers/ReceiverErrorRenderer';

const initialState = {
  records: [],
  loading: false,
  type: '',
  isReceiverAlarm: false,
  isPowerSupplyTypeAlarm: false,
  isNextReceiverAlarm: false,
  isNextPowerSupplyTypeAlarm: false,
};

export const isReceiverAlarmOccurred = (receiver) => {
  return (
    receiver._rer !== null &&
    !isNaN(receiver._rer) &&
    parseInt(receiver._rer) > 0
  );
};

export const isPowerSupplyTypeAlarmOccurred = (receiver) => {
  return (
    receiver._prs !== null &&
    !isNaN(receiver._prs) &&
    POWER_ERROR_CODES.includes(parseInt(receiver._prs))
  );
};
const ReceiversManagement = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case RECEIVERS_MANAGEMENT_ACTIONS.GET_RECEIVERS:
    case RECEIVERS_MANAGEMENT_ACTIONS.DELETE_RECEIVER:
      return produce(state, (draft) => {
        draft.loading = true;
        draft.type = type;
      });
    case RECEIVERS_MANAGEMENT_ACTIONS.GET_RECEIVERS_SUCCESS:
      const newReceivers = payload.records;
      const alarmSettings = payload.alarmSettings;

      newReceivers.forEach((receiver) => {
        // fake no alarm
        // receiver.rer = 0;
        // receiver.prs = 0;

        receiver._rer = receiver.rer;
        receiver._prs = receiver.prs;
        receiver.createdAt = receiver.createdAt || null;
      });

      let _isNextPowerSupplyTypeAlarm = false;
      let _isNextReceiverAlarm = false;

      const receiversAlarmFlagSnoozed =
        alarmSettings.deviceAlarmSettings?.alarmFlagsSnoozed?.receivers;
      if (receiversAlarmFlagSnoozed) {
        newReceivers.forEach((receiver) => {
          const _gatewayId = receiver.gatewayId;
          const abnormal_flags = receiver['afl'] || {};
          const gatewayIdSoonedFlags = receiversAlarmFlagSnoozed[_gatewayId];
          if (gatewayIdSoonedFlags) {
            if (gatewayIdSoonedFlags['_rer'] && !abnormal_flags.rer || parseInt(abnormal_flags.rer) === gatewayIdSoonedFlags['_rer']) {
              receiver._rer = undefined;
            }
            if (gatewayIdSoonedFlags['_prs'] && !abnormal_flags.prs || parseInt(abnormal_flags.prs) === gatewayIdSoonedFlags['_prs']) {
              receiver._prs = undefined;
            }
          }
        });
      }

      let isReceiverAlarm = false;
      let isPowerSupplyTypeAlarm = false;
      newReceivers.forEach((re) => {
        const isAlarm = isReceiverAlarmOccurred(re);
        const powerSupplyTypeAlarm = isPowerSupplyTypeAlarmOccurred(re);
        re.isAlarm = isAlarm;
        re.isPowerSupplyTypeAlarm = powerSupplyTypeAlarm;
        isReceiverAlarm = isReceiverAlarm || isAlarm;
        isPowerSupplyTypeAlarm = isPowerSupplyTypeAlarm || powerSupplyTypeAlarm;
      });

      if (!alarmSettings.isSnoozeExpired) {
        if (isReceiverAlarm) {
          _isNextReceiverAlarm = true;
        }
        if (isPowerSupplyTypeAlarm) {
          _isNextPowerSupplyTypeAlarm = true;
        }
      }

      return produce(state, (draft) => {
        draft.isNextReceiverAlarm = _isNextReceiverAlarm;
        draft.isNextPowerSupplyTypeAlarm = _isNextPowerSupplyTypeAlarm;
        draft.records = newReceivers;
        draft.loading = false;
        draft.isReceiverAlarm = isReceiverAlarm;
        draft.isPowerSupplyTypeAlarm = isPowerSupplyTypeAlarm;
        draft.type = type;
      });
    case RECEIVERS_MANAGEMENT_ACTIONS.GET_RECEIVERS_ERROR:
    case RECEIVERS_MANAGEMENT_ACTIONS.DELETE_RECEIVER_ERROR:
    case RECEIVERS_MANAGEMENT_ACTIONS.DELETE_RECEIVER_CLEAN_STATE:
      return produce(state, (draft) => {
        draft.loading = false;
        draft.type = type;
      });

    case RECEIVERS_MANAGEMENT_ACTIONS.DELETE_RECEIVER_SUCCESS:
      return produce(state, (draft) => {
        draft.records = state.records.filter((x) => x.gatewayId !== payload);
        draft.loading = false;
        draft.type = type;
      });
    case RECEIVERS_MANAGEMENT_ACTIONS.RESET_RECEIVER_NEXT_ALARM:
      return produce(state, (draft) => {
        draft.type = type;
        draft.isNextPowerSupplyTypeAlarm = false;
        draft.isNextReceiverAlarm = false;
      });

    default:
      return state;
  }
};

export default ReceiversManagement;
